

export const formatDate = (date) => {
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return new Intl.DateTimeFormat("en-US", options).format(date);
};

export const formatMessageTime = (timestamp) => {
  const now = new Date();
  const time = new Date(timestamp); // now valid
  const diff = (now - time) / 1000;

  let relative = "";

  if (diff < 60) relative = "Just now";
  else if (diff < 3600) relative = `${Math.floor(diff / 60)} minutes ago`;
  else if (diff < 86400) relative = `${Math.floor(diff / 3600)} hours ago`;
  else if (diff < 172800) relative = "Yesterday";
  else relative = time.toLocaleDateString();

  const exact = time.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return `${relative}, ${exact}`;
};


export const getRelativeTime = (timestamp) => {
    const now = new Date();
    const diff = now - new Date(timestamp);
    const days = Math.floor(diff / (1000 * 60 * 60 * 24)); // days
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // hours
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)); // minutes

    if (days > 0) {
        return `${days} day${days > 1 ? "s" : ""} ago, ${new Date(
            timestamp
        ).toLocaleTimeString("en-US")}`;
    } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? "s" : ""} ago, ${new Date(
            timestamp
        ).toLocaleTimeString("en-US")}`;
    } else if (minutes > 0) {
        return `${minutes} minute${minutes > 1 ? "s" : ""} ago, ${new Date(
            timestamp
        ).toLocaleTimeString("en-US")}`;
    } else {
        return `Just now, ${new Date(timestamp).toLocaleTimeString("en-US")}`;
    }
};